
<template>
  <div>
    <div>
      <deposit-profile v-if="oneDeposit && oneDeposit.data" :can_show_actions='false'></deposit-profile>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import depositProfile from './depositProfile.vue'

export default {
  components: { depositProfile },
  name: 'DepositDetail',
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapMutations({
      setOneDeposit: 'Financial/getOneFinancial'
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      oneDeposit: state => state.Financial.oneDeposit,
    })
  },
  mounted () {
    this.setOneDeposit({item: this.item, kind: 'deposits'});
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>